import { render, staticRenderFns } from "./TheReportConfig.vue?vue&type=template&id=12a5a0fe&scoped=true&"
import script from "./TheReportConfig.vue?vue&type=script&lang=js&"
export * from "./TheReportConfig.vue?vue&type=script&lang=js&"
import style0 from "./TheReportConfig.vue?vue&type=style&index=0&id=12a5a0fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a5a0fe",
  null
  
)

export default component.exports